import { atom } from "jotai";
import {
  nodesAtom,
  edgesAtom,
  togglesAtomResettable,
} from "@zapier/canvas-state";
import { outlineAtom } from "./outlineAtom";
import { fixAndParseJSON, streamNodesAndEdges } from "../utils";

export const streamNodesAndEdgesCommand = atom(null, (get, set) => {
  const toggles = get(togglesAtomResettable);

  if (!toggles.streamingUi) return;

  const outline = get(outlineAtom);

  try {
    const parsedData = fixAndParseJSON(outline);
    const { nodes, edges } = streamNodesAndEdges(parsedData);

    set(nodesAtom, nodes);
    set(edgesAtom, edges);
  } catch (error) {
    console.error("Error streaming nodes and edges", error);
  }
});

streamNodesAndEdgesCommand.debugLabel = "streamNodesAndEdgesCommand";
